import { render, staticRenderFns } from "./QuickNav.vue?vue&type=template&id=3a56fa90&"
import script from "./QuickNav.vue?vue&type=script&lang=js&"
export * from "./QuickNav.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "QuickNav.vue"
export default component.exports